import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M8 3 4 7l4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 7h16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 21 4-4-4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 17H4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowLeftRight";
const ArrowLeftRight = memo(themed(Icon));
export {
  ArrowLeftRight
};
//# sourceMappingURL=arrow-left-right.js.map
